<template>
  <el-dialog :close-on-click-modal="false" v-dialogDrag :title="title" :visible.sync="detailDialog" width="80%" append-to-body :before-close="handleClose">
    <!-- 明细 -->
    <div class="flex justify-start align-start flex-wrap padding-top">
      <el-form :inline="true" :model="form" ref="form" label-width="80px">
        <el-form-item label="单号:">
          <div class="form-width-sm">
            <span>{{ form.rechargeNum }}</span>
          </div>
        </el-form-item>
        <el-form-item label="单据日期:">
          <div class="form-width-sm text-cut">
            {{ form.rechargeDate }}
          </div>
        </el-form-item>
        <el-form-item label="名字:">
          <div class="form-width-sm">
            <span>{{ form.memberName }}</span>
          </div>
        </el-form-item>
        <el-form-item label="手机号码:">
          <div class="form-width-sm">
            <span>{{ form.mobilePhone }}</span>
          </div>
        </el-form-item>
        <br />
        <el-form-item label="充值方式:">
          <div class="form-width-sm  ">
            <el-tag v-if="form.liftType==0">标准</el-tag>
            <el-tag v-if="form.liftType==1">升级</el-tag>
            <el-tag v-if="form.liftType==2">降级</el-tag>
          </div>
        </el-form-item>
        <el-form-item label="充前类别:">
          <div class="form-width-sm">
            <span>{{ form.rawRechargeTypeName }}</span>
          </div>
        </el-form-item>
        <el-form-item label="充值类别:">
          <div class="form-width-sm">
            <span>{{ form.rechargeTypeName }}</span>
          </div>
        </el-form-item>
        <el-form-item label="标准金额:">
          <div class="form-width-sm">
            <span>{{ form.rechargeAmount }}</span>
          </div>
        </el-form-item>
        <br />
        <el-form-item label="充前金额:">
          <div class="form-width-sm">
            <span>{{ form.beforeMoney }}</span>
          </div>
        </el-form-item>
        <el-form-item label="充后金额:">
          <div class="form-width-sm">
            <span>{{ form.afterMoney }}</span>
          </div>
        </el-form-item>

        <el-form-item label="充前赠送:">
          <div class="form-width-sm">
            <span>{{ form.giftBeforeMoney }}</span>
          </div>
        </el-form-item>
        <el-form-item label="充后赠送:">
          <div class="form-width-sm">
            <span>{{ form.giftAfterMoney }}</span>
          </div>
        </el-form-item>
        <br />
        <el-form-item label="欠款:">
          <div class="form-width-sm">
            <span>{{ form.debtMoney }}</span>
          </div>
        </el-form-item>
        <el-form-item v-show="form.collectionIntegralAmount != 0" label="积分支付:">
          <div class="form-width-sm">
            <span>{{ form.collectionIntegralAmount }}</span>
          </div>
        </el-form-item>
        <el-form-item label="实付金额:">
          <div class="form-width-sm">
            <span>{{ form.collectionCashAmount }}</span>
          </div>
        </el-form-item>
        <el-form-item label="补单日期:" v-show="form.isAddition == 1">
          <div class="form-width-sm">
            <span>{{ form.additionDate }}</span>
          </div>
        </el-form-item>
        <br />
        <el-form-item label="说明:">
          <el-input v-model="form.description"></el-input>
        </el-form-item>
        <br>
        <el-form-item label="疗程赠送:" v-if="form.promotionProjectList">
          <div class="reatment">
            <el-table :data="form.promotionProjectList">
              <el-table-column align="center" prop="projectNum" label="疗程编码" ></el-table-column>
              <el-table-column align="center" prop="projectName" min-width="130" label="疗程名称" ></el-table-column>
              <el-table-column align="center" prop="times" label="赠送次数" ></el-table-column>
              <el-table-column align="center" prop="projectTotalMoney" label="活动金额" ></el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </el-form> 
      <div style="width:280px" class="border-radius-10 border margin-right-xs bg-white padding-xs">
        <el-table :data="form.payLists" :summary-method="getSummaries" show-summary>
          <el-table-column align="center" prop="payId" label="支付方式" min-width="100">
            <template slot-scope="scope">
              <el-select v-model="scope.row.payId" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="payMoney" label="支付金额" width="120"></el-table-column>
        </el-table>
      </div>
    </div>
    <br />
    <!-- <el-collapse v-model="activeNames" @change="collChange($event)">
      <el-collapse-item title="员工/门店管理层/高管业绩" name="员工"> -->
    <div class="flex justify-center align-start flex-wrap padding-top">
      <staffsles ref="staffsles" @staffslesData="staffslesData"></staffsles>
      <admin ref="admin" @adminData="adminData"></admin>
      <manager ref="manager" @managerData="managerData"></manager>
    </div>
    <!-- </el-collapse-item>
    </el-collapse> -->
    <span slot="footer" class="dialog-footer" v-if="title=='明细'">
      <el-button size="mini" type="primary" @click="detailDialog=false">关闭</el-button>
    </span>
    <span v-else slot="footer" class="dialog-footer">
      <!-- 补单才需要短信重发 -->
      <el-button size="mini" type="primary" @click="handleReissue">短信重发</el-button>
      <el-button size="mini" type="primary" plain @click="cancel()">取 消</el-button>
      <el-button v-if="form.isCancel==0" size="mini" type="primary" @click="subStaffRatio()" :loading="butloadIng">修 改</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { recEditStaff, selectOne,rechargeReissue,ctlist } from "@/api/eashier.js";
import admin from "@/components/staffList/admin/index";
import manager from "@/components/staffList/manager/index";
import staffsles from "@/components/staffList/staff/index";
export default {
  components: {
    staffsles,
    manager,
    admin,
  },
  data() {
    return {
      butloadIng:false,
      detailDialog: false,
      activeNames: "员工",
      title: "", //弹窗标题
      form: {}, //主对象
      options:[],
    };
  },
  created(){
    this.init()
  },
  methods: {
    init(){
      ctlist({
        state: 1
      }).then(res=>{
        console.log('res--->',res)
        this.options = res.rows.map(item=>{
          return {
            value:item.id,
            label:item.collectionTypeName
          }
        })
      })
    },
    // 短信重发
    handleReissue(){
      let params = {
        collectionAmount:this.form['collectionAmount'],
        additionDate:this.form['additionDate'],
        mobilePhone:this.form['mobilePhone'],
        rechargeAccountId:this.form['rechargeAccountId'],
        giftAfterMoney:this.form['giftAfterMoney'],
        giftBeforeMoney:this.form['giftBeforeMoney']
      }
      rechargeReissue(params).then(res=>{
        // console.log(res)
        if(res.code === '000000'){
          return this.$message.success({
              message: "操作成功!",
            });
        }else{
          this.$alert(res.message, "提示", {
            confirmButtonText: "确定",
            confirmButtonClass: "confirmbtnFalses",
            type: "warning",
            center: true,
            callback: (action) => {
            },
          });
        }
      })
    },
    //关闭弹窗前的回调方法
    handleClose() {
      this.form = Object.assign({});
      this.$refs.form.clearValidate();
      this.detailDialog = false;
    },
    collChange(e) {
      if (e.indexOf("员工")) {
        this.setStaff();
      }
    },
    setStaff() {
      var that = this;
      this.$nextTick(() => {
        that.$refs.staffsles.show(that.form.entities, that.form.storeId);
        that.$refs.admin.show(that.form.adminList, that.form.storeId);
        that.$refs.manager.show(that.form.managerList, that.form.storeId);
      });
    },
    //员工占比返回方法
    staffslesData(v) {
      this.form.entities = [...v];
    },
    //高管占比返回方法
    managerData(v) {
      this.form.managerList = [...v];
    },
    //管理员占比返回方法
    adminData(v) {
      this.form.adminList = [...v];
    },
    cancel() {
      this.detailDialog = false;
      this.$emit("detailData");
    },
    //组件传值
    show(form, text) {
      if (text == "明细") {
        this.title = text;
      } else {
        this.title = "充值单";
      }
      this.detailDialog = true;
      this.getData(form);
    },
    getData(row) {
      this.form = {
        ...row,
      };
      this.form.entities.forEach((item) => {
        item.staffName = item.saleStaffName;
        item.editStaffRatioShow = false;
        item.id = item.saleStaffId;
        item.identityCard = item.saleIdentityCard;
        item.ratio = item.saleRatio;
        item.staffNames = item.brandNumber + "--" + item.staffName;
      });
      selectOne({ type: 1, orderId: row.id }).then((res) => {
        if (res.code == "000000") {
          let managerList = [];
          let adminList = [];
          res.rows.forEach((item) => {
            if (item.staffType == 0) {
              item.staffNames = item.brandNumber + "--" + item.staffName;
              managerList.push(item);
            }
            if (item.staffType == 1) {
              item.staffNames = item.brandNumber + "--" + item.staffName;
              adminList.push(item);
            }
          });
          if (managerList.length == 0) {
            managerList.push({ ratio: 100 });
          }
          if (adminList.length == 0) {
            adminList.push({ ratio: 100 });
          }
          if (this.form.entities.length == 0) {
            this.form.entities.push({ ratio: 100 });
          }
          this.form.managerList = managerList;
          this.form.adminList = adminList;
          this.setStaff();
        } else {
          this.$alert(res.message, "加载门店高管", {
            confirmButtonText: "确定",
            confirmButtonClass: "confirmbtnFalses",
            type: "warning",
            center: true,
            callback: (action) => {},
          });
        }
      });
    },
    //指定列求和
    //数组按对应字段合计返回方法
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property == "payMoney") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              sums[index] = "--";
            }
          }, 0);
          sums[index] += " ";
        } else {
          sums[index] = "--";
        }
      });
      return sums;
    },
    subStaffRatio() {
      // payLists
      let staffLists = [];
      this.form.entities.forEach((item) => {
        let items = {
          ratio: item.ratio,
          id: item.id,
          identityCard: item.identityCard,
          staffName: item.staffName,
          brandNumber: item.brandNumber,
        };
        staffLists.push(items);
      });
      let salesmens = [];
      this.form.managerList.forEach((item) => {
        if (item.id) {
          item.staffType = 0;
          salesmens.push(item);
        }
      });
      this.form.adminList.forEach((item) => {
        if (item.id) {
          item.staffType = 1;

          salesmens.push(item);
        }
      });
      let form = {
        description:this.form.description,
        rechargeDate: this.form.rechargeDate,
        collectionAmount: this.form.collectionAmount,
        rechargeAmount: this.form.rechargeAmount,
        typeRatio: this.form.typeRatio,
        id: this.form.id,
        staffLists: staffLists,
        collectionCashAmount: this.form.collectionCashAmount,
        collectionIntegralAmount: this.form.collectionIntegralAmount,
        payLists:this.form.payLists.map(item=>{
          return{
            ...item,
            docId:this.form.rechargeNum
          }
        })
      };
      form.salesmens = salesmens;
      this.butloadIng = true
      recEditStaff(form).then((res) => {
        this.butloadIng = false
        if (res.code == "000000") {
          this.$message.success({
            message: res.message,
          });
          this.detailDialog = false;
          this.$emit("detailData");
        } else {
          this.$alert(res.message, "提示", {
            confirmButtonText: "确定",
            confirmButtonClass: "confirmbtnFalses",
            type: "warning",
            center: true,
            callback: (action) => {},
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.reatment{
  width: 600px;
}
</style>



// WEBPACK FOOTER //
// src/pages/eashier/collectionList/components/detail.vue